import { render } from "./PlacementUnit.vue?vue&type=template&id=e3659bc8&scoped=true"
import script from "./PlacementUnit.vue?vue&type=script&lang=js"
export * from "./PlacementUnit.vue?vue&type=script&lang=js"

import "./PlacementUnit.vue?vue&type=style&index=0&id=e3659bc8&scoped=true&lang=scss"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3659bc8"]])

export default __exports__